import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'refresh-banner',
  templateUrl: './refresh-banner.component.html'
})
export class RefreshBannerComponent implements OnInit {
  @Input() link: string;

  constructor(
  ) { }

  ngOnInit() {
  }
}
